import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, Transition as _Transition, renderList as _renderList } from "vue"

const _hoisted_1 = { class: "header-top" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "header-top-inner" }
const _hoisted_4 = { class: "search-wrapper" }
const _hoisted_5 = { class: "search-container" }
const _hoisted_6 = { class: "search-box" }
const _hoisted_7 = { class: "search-type-selector" }
const _hoisted_8 = { class: "search-input-wrapper" }
const _hoisted_9 = ["placeholder"]
const _hoisted_10 = { class: "nav-actions" }
const _hoisted_11 = { class: "user-avatar" }
const _hoisted_12 = ["src", "alt"]
const _hoisted_13 = { class: "user-pseudo" }
const _hoisted_14 = {
  key: 0,
  class: "dropdown-menu"
}
const _hoisted_15 = { class: "dropdown-item pseudo-display" }
const _hoisted_16 = { class: "pseudo-full" }
const _hoisted_17 = { class: "header-bottom" }
const _hoisted_18 = { class: "container" }
const _hoisted_19 = { class: "categories-scroll" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_NotificationBell = _resolveComponent("NotificationBell")!
  const _component_AuthModals = _resolveComponent("AuthModals")!

  return (_openBlock(), _createElementBlock("header", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_router_link, {
            to: "/",
            class: "logo"
          }, {
            default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
              _createElementVNode("img", {
                src: "/logo192.png",
                alt: "OKOLISY",
                class: "logo-img"
              }, null, -1)
            ]))]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("button", {
                    class: _normalizeClass(["type-btn", { active: _ctx.searchType === 'articles' }]),
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.searchType = 'articles'))
                  }, " Articles ", 2),
                  _createElementVNode("button", {
                    class: _normalizeClass(["type-btn", { active: _ctx.searchType === 'users' }]),
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.searchType = 'users'))
                  }, " Membres ", 2)
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_font_awesome_icon, {
                    icon: "search",
                    class: "search-icon"
                  }),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.searchQuery) = $event)),
                    placeholder: _ctx.searchType === 'articles' ? 'Rechercher un article...' : 'Rechercher un membre...',
                    class: "search-input",
                    onKeyup: _cache[3] || (_cache[3] = _withKeys(
//@ts-ignore
(...args) => (_ctx.executeSearch && _ctx.executeSearch(...args)), ["enter"]))
                  }, null, 40, _hoisted_9), [
                    [_vModelText, _ctx.searchQuery]
                  ]),
                  (_ctx.searchQuery)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "clear-search",
                        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.clearSearch && _ctx.clearSearch(...args)))
                      }, [
                        _createVNode(_component_font_awesome_icon, { icon: "times" })
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("button", {
                  class: "search-btn",
                  onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.executeSearch && _ctx.executeSearch(...args)))
                }, [
                  _createVNode(_component_font_awesome_icon, { icon: "search" })
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("a", {
              href: "#",
              class: "btn-sell",
              onClick: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleSellClick && _ctx.handleSellClick(...args)), ["prevent"]))
            }, [
              _createVNode(_component_font_awesome_icon, { icon: "plus" }),
              _cache[14] || (_cache[14] = _createElementVNode("span", null, "Vends tes articles", -1))
            ]),
            (_ctx.isAuthenticated)
              ? (_openBlock(), _createBlock(_component_NotificationBell, { key: 0 }))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              class: "user-menu",
              onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.toggleUserMenu && _ctx.toggleUserMenu(...args))),
              ref: "userMenuRef"
            }, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("img", {
                  src: _ctx.userPhoto,
                  alt: _ctx.userPseudo || 'User',
                  class: "avatar-img",
                  onError: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.handleAvatarError && _ctx.handleAvatarError(...args)))
                }, null, 40, _hoisted_12)
              ]),
              _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.userPseudo || 'Compte'), 1),
              _createElementVNode("span", {
                class: _normalizeClass(["chevron-icon", { rotated: _ctx.showUserMenu }])
              }, [
                _createVNode(_component_font_awesome_icon, { icon: "chevron-down" })
              ], 2),
              _createVNode(_Transition, { name: "fade" }, {
                default: _withCtx(() => [
                  (_ctx.showUserMenu)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                        (!_ctx.isAuthenticated)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createElementVNode("a", {
                                href: "#",
                                class: "dropdown-item",
                                onClick: _cache[8] || (_cache[8] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.showLoginModal && _ctx.showLoginModal(...args)), ["prevent"]))
                              }, [
                                _createVNode(_component_font_awesome_icon, { icon: "sign-in-alt" }),
                                _cache[15] || (_cache[15] = _createTextVNode(" Se connecter ", -1))
                              ]),
                              _createElementVNode("a", {
                                href: "#",
                                class: "dropdown-item",
                                onClick: _cache[9] || (_cache[9] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.showRegisterModal && _ctx.showRegisterModal(...args)), ["prevent"]))
                              }, [
                                _createVNode(_component_font_awesome_icon, { icon: "user-plus" }),
                                _cache[16] || (_cache[16] = _createTextVNode(" S'inscrire ", -1))
                              ])
                            ], 64))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createElementVNode("div", _hoisted_15, [
                                _createVNode(_component_font_awesome_icon, { icon: "user" }),
                                _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.userPseudo), 1)
                              ]),
                              _cache[22] || (_cache[22] = _createElementVNode("hr", { class: "dropdown-divider" }, null, -1)),
                              _createVNode(_component_router_link, {
                                to: "/mon-profil",
                                class: "dropdown-item",
                                onClick: _ctx.closeUserMenu
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_font_awesome_icon, { icon: "cog" }),
                                  _cache[17] || (_cache[17] = _createTextVNode(" Mon profil ", -1))
                                ]),
                                _: 1
                              }, 8, ["onClick"]),
                              _createVNode(_component_router_link, {
                                to: "/mes-annonces",
                                class: "dropdown-item",
                                onClick: _ctx.closeUserMenu
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_font_awesome_icon, { icon: "box" }),
                                  _cache[18] || (_cache[18] = _createTextVNode(" Mes annonces ", -1))
                                ]),
                                _: 1
                              }, 8, ["onClick"]),
                              _createVNode(_component_router_link, {
                                to: "/mes-commandes",
                                class: "dropdown-item",
                                onClick: _ctx.closeUserMenu
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_font_awesome_icon, { icon: "shopping-bag" }),
                                  _cache[19] || (_cache[19] = _createTextVNode(" Mes commandes ", -1))
                                ]),
                                _: 1
                              }, 8, ["onClick"]),
                              _createVNode(_component_router_link, {
                                to: "/mes-favoris",
                                class: "dropdown-item",
                                onClick: _ctx.closeUserMenu
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_font_awesome_icon, { icon: "heart" }),
                                  _cache[20] || (_cache[20] = _createTextVNode(" Mes favoris ", -1))
                                ]),
                                _: 1
                              }, 8, ["onClick"]),
                              _cache[23] || (_cache[23] = _createElementVNode("hr", { class: "dropdown-divider" }, null, -1)),
                              _createElementVNode("a", {
                                href: "#",
                                class: "dropdown-item logout",
                                onClick: _cache[10] || (_cache[10] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleLogout && _ctx.handleLogout(...args)), ["prevent"]))
                              }, [
                                _createVNode(_component_font_awesome_icon, { icon: "sign-out-alt" }),
                                _cache[21] || (_cache[21] = _createTextVNode(" Déconnexion ", -1))
                              ])
                            ], 64))
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ], 512)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_17, [
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("div", _hoisted_19, [
          _createVNode(_component_router_link, {
            to: "/",
            class: _normalizeClass(["category-link", { active: !_ctx.selectedCategoryId && _ctx.currentRoute === '/' }]),
            onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.selectMainCategory(null)))
          }, {
            default: _withCtx(() => [...(_cache[24] || (_cache[24] = [
              _createTextVNode(" Tous les articles ", -1)
            ]))]),
            _: 1
          }, 8, ["class"]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mainCategories, (cat) => {
            return (_openBlock(), _createBlock(_component_router_link, {
              key: cat.id,
              to: "/",
              class: _normalizeClass(["category-link", { active: _ctx.selectedCategoryId === cat.id }]),
              onClick: ($event: any) => (_ctx.selectMainCategory(cat.id))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(cat.nom), 1)
              ]),
              _: 2
            }, 1032, ["class", "onClick"]))
          }), 128))
        ])
      ])
    ]),
    _createVNode(_component_AuthModals, {
      "show-login-modal": _ctx.showLogin,
      "show-register-modal": _ctx.showRegister,
      onCloseModals: _ctx.closeModals,
      onSwitchToLogin: _ctx.switchToLogin,
      onSwitchToRegister: _ctx.switchToRegister,
      onLoginSuccess: _ctx.handleAuthSuccess,
      onRegisterSuccess: _ctx.handleAuthSuccess
    }, null, 8, ["show-login-modal", "show-register-modal", "onCloseModals", "onSwitchToLogin", "onSwitchToRegister", "onLoginSuccess", "onRegisterSuccess"])
  ]))
}